import { TEXT } from "../configs/text"

export interface UserInfo {
    id: number
    full_name: string
    email: string
    avatar?: string
}

export enum UserRole {
    student = 'Student',
    teacher = 'Teacher',
    ac_ao = 'AC/AO'
}

export const userRoleMap = {
    [UserRole.student]: TEXT.student,
    [UserRole.teacher]: TEXT.teacher,
    [UserRole.ac_ao]: TEXT.ac_ao
}